import DevBoard from './dev-board';

export default DevBoard;
